'use client';

import styled from '@emotion/styled';

import { type ButtonProps, ButtonStyles } from '@hrworks/sui-core/Button';

import { mq } from '../../util/mediaQueries';
import { Link } from '../Link';

const BaseButton = styled(Link)<ButtonProps>(({ theme, width, corner, size, color, variant, textAlign }) =>
  ButtonStyles.generateButtonStyles({ theme, width, corner, size, color, variant, textAlign }),
);

export const LinkButton = styled(BaseButton)(({ theme }) => ({
  backgroundColor: theme.stellenportal?.buttonStyle?.color || theme.eclipseTier2Color.text.default,
  color: theme.stellenportal?.buttonStyle?.fontStyle?.color || theme.eclipseTier2Color.background.brand.bold.default,
  [mq.supportsHover]: {
    '&&:hover': {
      opacity: 0.8,
    },
  },
}));
